<template>
  <div class="message-container" :class="severity">
    <span class="message">{{message}}</span>
  </div>
</template>

<script>
export default {
  name: 'Message',
  props: {
    message: {
      type: String,
    },
    type: {
      type: String,
    },
  },
  computed: {
    severity() {
      if (this.type === 'error') {
        return 'message-box error';
      }
      if (
        this.type === 'warning') {
        return 'message-box warning';
      }
      return 'message-box info';
    },
  },
};
</script>

<style scoped lang="scss">
  .message-box {
    padding: 20px;
    font-size: rem(18px);
    font-weight: bold;
    border: 2px solid $turquoise;
    margin: 35px 0;

    &.info {
      color: $peacock-blue;
      background-color: lighten($peacock-blue, 50%);
      border-color: $peacock-blue;
    }

    &.error {
      color: $red;
      background-color: lighten($red, 40%);
      border-color: $red;
    }

    &.warning {
      color: $yellow;
      background-color: lighten($yellow, 25%);
      border-color: $yellow;
    }
  }


</style>
